import { mobileApi, mobileRequest } from './mobileApi';

export const mobileBeneficiaryService = {
  getBeneficiaries: async (params = {}) => {
    return mobileRequest(() => mobileApi.get('/beneficiarymaster', { params }));
  },

  getBeneficiaryById: async (id) => {
    return mobileRequest(() => mobileApi.get(`/beneficiarymaster/${id}`));
  },

  createBeneficiary: async (data) => {
    return mobileRequest(() => mobileApi.post('/beneficiarymaster', data));
  },

  updateBeneficiary: async (id, data) => {
    return mobileRequest(() => mobileApi.put(`/beneficiarymaster/${id}`, data));
  },

  deleteBeneficiary: async (id) => {
    return mobileRequest(() => mobileApi.delete(`/beneficiarymaster/${id}`));
  }
};
